import { useMemo } from 'react';
import Navbar from 'src/components/NavBar';
import { MESSAGE_MODE, MessageMode } from 'src/constants/messageMode';
import useCompany from 'src/hooks/useCompany';
import useViewMessage from 'src/hooks/useViewMessage';
import ViewMessageNavbar from './ViewMessageNavbar';
import ViewMessageTable from './ViewMessageTable';

interface ManageMessageProps {
  mode: MessageMode;
}

const ManageMessage = ({ mode }: ManageMessageProps) => {
  const { company } = useCompany();
  const { selectedMessage, t, pageTitle, unreadCount, sentCount, currentClientId } =
    useViewMessage();

  const displayTitle = useMemo(() => {
    if (mode === MESSAGE_MODE.INBOX) {
      return `${pageTitle}${unreadCount > 0 ? ` (${unreadCount} ${t('unread')})` : ''}`;
    }
    if (mode === MESSAGE_MODE.OUTBOX) {
      return `${pageTitle}${sentCount > 0 ? ` (${sentCount} ${t('sent')})` : ''}`;
    }
    return pageTitle;
  }, [pageTitle, mode, unreadCount, sentCount, t]);

  return (
    <>
      <Navbar title={displayTitle} />
      {Object.keys(selectedMessage).length ? (
        <>
          <main className="mx-4">
            <div className="flex flex-row mt-4 gap-6">
              {/* Message details view could go here */}
            </div>
          </main>
        </>
      ) : (
        <>
          <ViewMessageNavbar />
          {company?.companyId || currentClientId ? (
            <>
              <ViewMessageTable />
            </>
          ) : (
            <>
              {console.log('ManageMessage - Not rendering ViewMessageTable, both missing:', {
                company,
                currentClientId,
              })}
              <p className="text-center text-sm font-bold mt-6">{t('')}</p>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ManageMessage;
